import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Message } from 'semantic-ui-react';

import { DocumentList } from '../DocumentList';

/* eslint-disable react/prefer-stateless-function */
class Saved extends Component {
  render() {
    const { auth } = this.props;
    if (!auth) return null;
    if (auth.documents.length > 0) {
      return <DocumentList documents={auth.documents} />;
    }
    return (
      <Message compact color="yellow">
        <Message.Header>Coleção vazia</Message.Header>
        <p>Você ainda não salvou nenhum documento.</p>
      </Message>
    );
  }
}
/* eslint-enable react/prefer-stateless-function */

Saved.propTypes = {
  auth: PropTypes.any,
};

const mapStateToProps = ({ auth }) => ({ auth });

export default connect(mapStateToProps)(Saved);



// WEBPACK FOOTER //
// ./src/components/Saved/Saved.js